<template>
  <div>
    <c404></c404>
    <footerSection></footerSection>
    <a href="#" class="go-top"><i class="fa fa-angle-up"></i></a>
  </div>
</template>

<script>
import headerSection from '../components/header.vue';
import footerSection from '../components/footer.vue';
import c404 from '../components/404.vue';
  export default {
    components: {
      //headerSection,
      footerSection,c404
    },
    mounted: function() {
       $(window).scroll(function() {
      if ($(this).scrollTop() > 200) {
          $('.go-top').fadeIn(200);
            } else {
                $('.go-top').fadeOut(200);
           }
        });
          // Animate the scroll to top
        $('.go-top').click(function(event) {
          event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 300);
    });

    }
   }
</script>
<style>
  .page404{
    color: #AC2925;
  }
  
  #app {
    /*font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,PingFang SC,Noto Sans,Noto Sans CJK SC,Microsoft YaHei !important;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/404.vue